import { ContactDetail } from './contact-detail';
import { ContactIndividual } from './contact-individual';

export class Contact {
  id: number;
  center_id: number;
  status: string = null;
  code: string = null;
  fullname: string = null;
  code_fullname: string = null;
  type: string = null; // "NULL" In order to select the default option in select
  type_value?: string;
  photo_contact: Record<string, any>;
  cover_url: string;
  contactDetail?: ContactDetail;
  contact_detail?: ContactDetail;
  billing_contact_detail?: ContactDetail;
  billingContactDetail?: ContactDetail;
  language: string = null;
  company_name: string;
  juridic_form: string = null;
  vat_number: string;
  start_date: string;
  end_date: Date;
  contactIndividual?: ContactIndividual;
  contact_individual?: ContactIndividual;
  same_as_contact_details = true;
  allow_online_invoice_payment: boolean;
  job_title: string;
  price_category_id: number;
  default_invoice_layout?: string;
  apply_free_orders: boolean;
  color: string;
}
